import React from 'react';

import { Modal } from 'src/components/common';
import { InvitePeoStaffByPeoAdminModalForm } from 'src/components/peoStaff';
import { ModalId } from 'src/constants/modals';
import { useModal } from 'src/hooks/shared';

export const InvitePeoStaffByPeoAdminModal: React.FC = () => {
  const { closeModal, switchClosability, isOpen } = useModal(ModalId.InvitePeoStaffByPeoAdminModal);

  const onCloseModal = React.useCallback(() => {
    closeModal();
  }, [closeModal]);

  return (
    <Modal
      title="Invite Staff"
      dialogProps={{
        onClose: onCloseModal,
        open: isOpen,
      }}
      maxWidth={740}
      headerPadding="32px 32px 4px"
      headerProps={{
        sx: {
          lineHeight: '28px',
        },
      }}
      contentProps={{
        sx: {
          pt: 0,
        },
      }}
    >
      <InvitePeoStaffByPeoAdminModalForm
        closeModal={onCloseModal}
        switchClosability={switchClosability}
      />
    </Modal>
  );
};
